import { Component, Input } from "@angular/core";

@Component({
  selector: "app-language-flag",
  templateUrl: "language-flag.html",
})
export class LanguageFlagComponent {

  @Input() public lang: string;
}



// WEBPACK FOOTER //
// ./src/components/language-flag/language-flag.ts